module.exports = __webpack_public_path__ + "img/c250_01_400x200.de8f274b.jpg";